import { useAppSelector } from '@energy-stacks/csms/store';
import { environment } from '@energy-stacks/feature-config';

const logoUrl =
  environment.ocppServiceUrl + '/ui-configuration/public/logo.svg';

export const CsmsLogo = () => {
  const logoHashDate = useAppSelector((state) => state.logoHash.logoHashDate);
  const uniqueSource = logoUrl + '?' + logoHashDate;

  return (
    <img
      data-testid="brokerLogoImage"
      src={uniqueSource}
      alt="logo"
      height="auto"
      width="auto"
      style={{
        maxWidth: '100%',
        maxHeight: '100%',
      }}
    />
  );
};
